<burndown-chart-body
  [sumToBurn]="(sumToBurn$ | async)"
  [startTs]="(startTs$ | async)"
  [endTs]="(endTs$ | async)"
  [releasedTs]="(releasedDate$ | async)"
  [mode]="mode$ | async"
  [burnEvents]="burnEvents$ | async"
></burndown-chart-body>
